import "./BusyComboBox2.scss";
import block from "bem-cn";
import { useEffect, useState } from "react";
import { busyIncludes, TBusyValue } from "./BusyComboBox2.utils";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { changeBusyList, selectFilterBusy } from "../Filter/FilterSlice";

const b = block("BusyComboBox2");

export type item = {
  isChecked: boolean;
  color: string;
  colorUnchecked: string;
  value: TBusyValue;
};

type Props = {
  items: item[];
};

const BusyComboBox2 = ({ items }: Props) => {
  const [checkedItems, setCheckedItems] = useState<boolean[]>(
    items.map((item) => item.isChecked)
  );
  const dispatch = useAppDispatch();
  const busy = useAppSelector(selectFilterBusy);

  const onHandleInputChange = (index: number) => {
    const cItems = checkedItems.map((item, i) =>
      i === index ? !checkedItems[index] : item
    );

    const isCheckedCount = cItems.filter((item) => item).length;
    if (isCheckedCount === 0) cItems[index] = true;

    setCheckedItems(cItems);

    const busyList: TBusyValue[] = [];
    items.forEach(({ value }, index) => cItems[index] && busyList.push(value));

    console.log(busyList);
    dispatch(changeBusyList(busyList));
  };

  const coloredCheckBox = ({ color, colorUnchecked }: item, index: number) => (
    <label className={b("checkbox")}>
      <input
        checked={checkedItems[index]}
        className={b("input")}
        type="checkbox"
        onChange={() => onHandleInputChange(index)}
      />
      <div
        className={b("checkbox-content")}
        style={{ background: checkedItems[index] ? color : colorUnchecked }}
      />
    </label>
  );

  useEffect(() => {
    if (busy.length) {
      const newValues: boolean[] = [];
      items.forEach((item) => {
        newValues.push(busyIncludes(busy, item));
      });
      setCheckedItems(newValues);
    }
  }, [busy, items]);

  return (
    <div className={b()}>
      <p className={b("caption")}>Выберите:</p>
      <ul className={b("list")}>
        {items.map((item, index) => (
          <li key={index} className={b("item")}>{coloredCheckBox(item, index)}</li>
        ))}
      </ul>
    </div>
  );
};

export default BusyComboBox2;
